import React from "react";

import Jumbotron from "../Jumbotron";
import "./style.css";

const CustomCarousel: React.FC = () => (
  <Jumbotron margin="10px auto" height="90vh">
    <div className="slider">
      <div className="slides">
        <div id="zV2iuvFqADE">
          <iframe
            title="Sun set"
            width="90%"
            height="90%"
            src="https://www.youtube.com/embed/zV2iuvFqADE"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
        <div id="JPEkFOVzOm8">
          <iframe
            title="GoldenBridge"
            width="90%"
            height="90%"
            src="https://www.youtube.com/embed/JPEkFOVzOm8"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
        <div id="pvzwNfLWHt4">
          <iframe
            title="Moon"
            width="90%"
            height="90%"
            src="https://www.youtube.com/embed/pvzwNfLWHt4"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
        <div id="cYymR4tE02s">
          <iframe
            width="90%"
            title="sofa"
            height="90%"
            src="https://www.youtube.com/embed/cYymR4tE02s"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
        <div id="N20CINc1Xxg">
          <iframe
            width="90%"
            title="Rain"
            height="90%"
            src="https://www.youtube.com/embed/N20CINc1Xxg"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
      </div>
    </div>
  </Jumbotron>
);

export default CustomCarousel;
